// extracted by mini-css-extract-plugin
export default {"wrapper":"VsiiBI7aUeOzeo7WqrwS","button":"NI5D2At5Dip72KF9OgbL","icon":"QcP2ySdNYzPS78DKgNNU"};